
export const BASE_URL = "";
// export const BASE_URL = "http:152.42.230.223";
//export const BASE_URL = "https://aisleaiagents.sltdigitallab.lk";

export const URL = {
    GET_TOKEN_DIGITAL: `${BASE_URL}/api/get_token_digital`,
    GET_TOKEN_EMBRYO: `${BASE_URL}/api/get_token_embryo`,
    GET_TOKEN_INNOSPACE: `${BASE_URL}/api/public/get_token_innospace`,
    GET_TOKEN_PLACEMENT: `${BASE_URL}/api/public/get_token_placement`,
    GET_TOKEN_TEST: `${BASE_URL}/api/get_token_test`,
    GET_TOKEN_SLTMNIT: `${BASE_URL}/api/public/get_token_sltmnit`,
    GET_TOKEN_ASKHR: `${BASE_URL}/api/get_token_askhr`,
    GET_TOKEN_ASKENTERPRISE: `${BASE_URL}/api/get_token_askenterprise`,
    GET_TOKEN_INIFINIAI: `${BASE_URL}/api/public/get_token_inifiniai`,
    GET_TOKEN_ASKFINANCE_COPILOT: `${BASE_URL}/api/get_token_askfinance_copilot`,
    GET_TOKEN_WORKMATE: `${BASE_URL}/api/get_token_workmate`,

    CONTACT_SUBMIT: `${BASE_URL}/api/public/contact-submit`,

    CHAT_EKB: `${BASE_URL}/api/public/chat_ekb`,

}